import { render, staticRenderFns } from "./WorkflowTestTaskAdd.vue?vue&type=template&id=15d02922"
import script from "./WorkflowTestTaskAdd.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports